/** @jsxImportSource @emotion/react */
import { FC } from "react";

export const BpayIcon: FC<{}> = () => (
  <svg
    css={{
      display: "block",
    }}
    width="24"
    height="24"
    viewBox="0 0 32 32"
    focusable="false"
    role="img"
  >
    <path
      d="M16 24c-4.411 0-8-3.589-8-8 0-4.412 3.589-8 8-8s8 3.588 8 8c0 4.411-3.589 8-8 8m0-18C10.478 6 6 10.477 6 16c0 5.522 4.478 10 10 10s10-4.478 10-10c0-5.523-4.478-10-10-10"
      fill="#fff"
    />
  </svg>
);
